import { Link as RouterLink } from 'react-router-dom';
import { Link, Stack, Typography } from '@mui/material';
import { PATH_AUTH } from '../../routes/paths';
import AuthShell from '../../components/auth/AuthShell';
import { LoginForm } from '../../sections/auth/login';

export default function Login() {
  return (
    <AuthShell
      pageTitle="Login"
      showBack={false}
      title="Login"
      subtitle="Enter your login details"
      footer={
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Don&apos;t have an account?
          </Typography>
          <Link
            component={RouterLink}
            to={PATH_AUTH.register}
            variant="subtitle2"
            sx={{ color: 'primary.main', fontWeight: 800, textDecoration: 'underline' }}
          >
            Sign Up.
          </Link>
        </Stack>
      }
    >
      <LoginForm />
    </AuthShell>
  );
}
